import React, { useState } from 'react'

export function DeadlineFacet({ deadline, onUpdate }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState('')

  if (!deadline?.date && !onUpdate) return null

  const dateStr = deadline?.date || ''
  const days = dateStr ? Math.ceil((new Date(dateStr) - Date.now()) / 86400000) : null
  let urgency = styles.normal
  if (days !== null) {
    if (days < 0) urgency = styles.overdue
    else if (days <= 30) urgency = styles.urgent
  }

  const label = days !== null
    ? (days > 0 ? `${days}d remaining` : days === 0 ? 'Due today' : `${Math.abs(days)}d overdue`)
    : null

  function startEdit() {
    if (!onUpdate) return
    setDraft(dateStr)
    setEditing(true)
  }

  function commitEdit() {
    if (draft && draft !== dateStr) onUpdate?.(draft)
    setEditing(false)
  }

  return (
    <div style={styles.facet}>
      {editing ? (
        <input
          type="date"
          style={styles.editInput}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commitEdit}
          onKeyDown={(e) => e.key === 'Enter' && commitEdit()}
          autoFocus
        />
      ) : (
        <span
          style={{ ...styles.date, ...(onUpdate ? styles.clickable : {}) }}
          onClick={startEdit}
        >
          {dateStr || 'Set deadline...'}
        </span>
      )}
      {label && <span style={{ ...styles.label, ...urgency }}>{label}</span>}
    </div>
  )
}

const styles = {
  facet: { display: 'flex', alignItems: 'center', gap: '8px' },
  date: { fontSize: '12px', color: 'var(--text-primary)' },
  clickable: { cursor: 'pointer', borderBottom: '1px dashed var(--border)' },
  label: { fontSize: '10px', fontWeight: 500, padding: '1px 6px', borderRadius: '8px' },
  normal: { background: '#f0f0ee', color: 'var(--text-secondary)' },
  urgent: { background: '#e89a5d18', color: '#8a5a2a' },
  overdue: { background: '#e85d5d18', color: '#8a2a2a' },
  editInput: {
    fontSize: '12px',
    padding: '2px 6px',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    background: 'var(--bg)',
    color: 'var(--text-primary)',
  },
}
